import { requestApi } from '@app/api';
import { withIdentityAccess } from '@app/api/paths';

interface GetUserPasswordChangeCheckResponse {
  result: {
    isChanged: boolean;
  };
}
/**
 * 비밀번호 최근에 변경했는지 조회
 */
export function getUserPasswordChangeCheck(): Promise<boolean> {
  return requestApi<GetUserPasswordChangeCheckResponse>({
    url: withIdentityAccess('/user/password/change/check'),
    method: 'GET',
    credentials: true,
  }).then((response) => response.data.result.isChanged);
}

/**
 * 비밀번호 변경일 연기
 */
export function postUserPasswordChangePostpone() {
  return requestApi({
    url: withIdentityAccess('/user/password/change/postpone'),
    method: 'POST',
    credentials: true,
  });
}
